import { NextFetchRequestInit } from '@/app/types';

export const DEFAULT_ITEMS_PER_PAGE = 10;
export const MAXIMUM_ITEMS_PER_PAGE = 99;
export const SESSION_ID_COOKIE_KEY = 'PHPSESSID';
export const REMEMBER_ME_COOKIE_KEY = 'REMEMBERME';
export const SUBPROJECT_SEARCH_PARAM_KEY = 'subproject';
export const REWARD_SEARCH_PARAM_KEY = 'reward';
export const REWARD_VARIANT_SEARCH_PARAM_KEY = 'rewardVariant';
export const LANG_URL_KEY = 'lang';
export const LANGUAGE_COOKIE_KEY = 'language';
export const STORED_COOKIE_REQUEST_KEY = 'cookie';
export const DOWNLOAD_POSTER_PREVIEW_URL = `:originUrl/pribeh/:numericId/other/poster.html`;
export const TIME_LEFT_WARNING_THRESHOLD_IN_DAYS = 7;
export const CHATBOT_URL = 'https://chat-widget.amio.io/static/amio-webchat-loader.min.js';
export const DEFAULT_CACHE_TIME_IN_SECONDS = 10;
export const COUNT_UP_DURATION_IN_SECONDS = 2;
export const DEFAULT_CACHE_CONTROL: NextFetchRequestInit = {
  cache: 'force-cache',
  next: { revalidate: DEFAULT_CACHE_TIME_IN_SECONDS },
} as NextFetchRequestInit;
